import * as Yup from "yup";

const Login = Yup.object().shape({
  username: Yup.string().required("Bitte geben Sie einen Benutzernamen ein."),
  password: Yup.string().required("Bitte geben Sie Ihr Passwort ein."),
});

const DeliveryAddress = Yup.object().shape({
  city: Yup.string().required("Bitte geben Sie eine Stadt ein."),
  country: Yup.string().required("Bitte geben Sie ein Land ein."),
  street: Yup.string().required("Bitte geben Sie eine Straße ein."),
  zip: Yup.string().required("Bitte geben Sie eine Postleitzahl ein."),
});

const InvoiceAddress = Yup.object().shape({
  city: Yup.string().required("Bitte geben Sie eine Stadt ein."),
  country: Yup.string().required("Bitte geben Sie ein Land ein."),
  street: Yup.string().required("Bitte geben Sie eine Straße ein."),
  zip: Yup.string().required("Bitte geben Sie eine Postleitzahl ein."),
});

const Commission = Yup.object().shape({
  commission_required: Yup.boolean().required(),
  commission_text: Yup.string().when("commission_required", {
    is: true,
    then: Yup.string()
      .min(1)
      .required("Bitte geben Sie einen Kommissionstext ein."),
  }),
});

// Form Steps One.
export const StepOneSchema = Yup.object().shape({
  customer_invoice_address: InvoiceAddress,
  customer_delivery_address_eq_invoice_address: Yup.boolean().required(),
  customer_delivery_address: DeliveryAddress,
  customer_delivery_address_id: Yup.string().nullable(),
});

export const StepTwoSchema = Yup.object().shape({
  customer_email: Yup.string()
    .email("Bitte geben Sie eine gültige E-Mail-Adresse an.")
    .required("Bitte geben Sie eine gültige E-Mail-Adresse an."),
  frame_configuration: Yup.object().shape({
    frame_formers: Yup.object().shape({
      formers_required: Yup.boolean().required(),
    }),
    frame_temples_imprint: Yup.object({
      temples_imprint_required: Yup.boolean().required(),
      temples_imprint_text: Yup.string(),
    }),
  }),
  order_information: Yup.object().shape({
    order_type_preview: Yup.boolean().required(),
    order_type_invoice: Yup.boolean().required(),
    order_commission: Commission,
  }),
});



// WEBPACK FOOTER //
// ../shop_main/util/schemas.js